/* ============================================================
   EI Mama — Landing Fête des mères 2026
   Sprint Mama Étape 1 — 2026-05-14
   ============================================================
   Logique :
   - Pop-ups (petit mot + collection), un seul ouvert à la fois
   - Petit mot pour 3 coffrets + sélection composée (produit porteur)
   - ATC interception POUR ENRICHIR les forms avec hidden inputs petit mot
     (le submit lui-même est ensuite traité par Cart V1)
   - Sticky bar (read /cart.js + progress vers livraison offerte)
   - Tracking GA4 : view, scroll_50, coffret_atc, compose_atc, petitmot_used, checkout
   ============================================================ */

(function () {
  'use strict';

  if (!document.querySelector('[data-ei-mama-root]')) return;

  var CONFIG = window.EI_MAMA_CONFIG || {};
  var SEUIL_RELAIS = CONFIG.seuilRelaisCents || 4900;   // 49 €
  var SEUIL_DOMICILE = CONFIG.seuilDomicileCents || 9000; // 90 €

  /* ===== State global ===== */
  window.eiMamaState = {
    /* Petit mot par coffret : { iconique: {carton, message}, tunefaisrien: {...}, dolce: {...} } */
    coffrets: {},
    /* Petit mot pour la sélection composée */
    compose: null, // { carton, message } ou null
    /* Variant ID du "produit porteur" de la sélection composée (1er produit composé ajouté) */
    composeLeadVariantId: null,
    /* Petit mot pour la carte cadeau (Étape 2) */
    cartecadeau: null, // { carton, message } ou null
    /* Contexte d'ouverture de la pop-up petit mot */
    petitMotContext: null  // { source: 'coffret' | 'compose' | 'cartecadeau', coffretId?: string }
  };

  /* ===== Helpers ===== */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function pushGA4(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) { /* silencieux */ }
  }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  /* ============================================================
     POP-UPS (gestion globale, 1 seul à la fois)
     ============================================================ */
  function closeAllPopups() {
    $$('.ei-mama-popup-overlay').forEach(function (overlay) {
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('ei-mama-popup-open');
  }

  function openPopup(name) {
    closeAllPopups();
    var overlay = document.querySelector('[data-ei-mama-popup="' + name + '"]');
    if (!overlay) return;
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ei-mama-popup-open');
  }

  /* Délégation : close buttons + backdrop */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ei-mama-popup-close]')) {
      closeAllPopups();
    }
  });

  /* Escape ferme la pop-up active */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPopups();
  });

  /* ============================================================
     POP-UP PETIT MOT
     ============================================================ */
  function openPetitMotPopup(source, coffretId) {
    window.eiMamaState.petitMotContext = { source: source, coffretId: coffretId || null };

    /* Pré-remplir avec le mot existant si déjà saisi */
    var existing = null;
    if (source === 'coffret' && coffretId) {
      existing = window.eiMamaState.coffrets[coffretId] || null;
    } else if (source === 'compose') {
      existing = window.eiMamaState.compose;
    } else if (source === 'cartecadeau') {
      existing = window.eiMamaState.cartecadeau;
    }

    var textarea = $('[data-ei-mama-message]');
    var counter = $('[data-ei-mama-charcount]');
    if (textarea) textarea.value = existing ? existing.message : '';
    if (counter) counter.textContent = textarea ? String(textarea.value.length) : '0';

    /* Sélection carton */
    $$('.ei-mama-carton').forEach(function (btn) {
      var isSel = existing && btn.dataset.eiMamaCarton === existing.carton;
      btn.setAttribute('aria-checked', isSel ? 'true' : 'false');
    });

    /* Box inspi : repliée */
    var inspi = $('[data-ei-mama-inspi]');
    var toggle = $('[data-ei-mama-toggle-inspi]');
    if (inspi) inspi.setAttribute('hidden', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    openPopup('petitmot');
  }

  /* Ouvrir la popup depuis les boutons */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-ei-mama-open-petitmot]');
    if (openBtn) {
      var source = openBtn.dataset.eiMamaPetitmotSource;
      var coffretId = openBtn.dataset.eiMamaPetitmotCoffret;
      openPetitMotPopup(source, coffretId);
    }
  });

  /* Sélection d'un carton */
  document.addEventListener('click', function (e) {
    var carton = e.target.closest('[data-ei-mama-carton]');
    if (!carton) return;
    $$('.ei-mama-carton').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    carton.setAttribute('aria-checked', 'true');
  });

  /* Compteur de caractères */
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ei-mama-message]')) {
      var counter = $('[data-ei-mama-charcount]');
      if (counter) counter.textContent = String(e.target.value.length);
    }
  });

  /* Toggle box inspi */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ei-mama-toggle-inspi]')) return;
    var inspi = $('[data-ei-mama-inspi]');
    var toggle = $('[data-ei-mama-toggle-inspi]');
    if (!inspi || !toggle) return;
    var isOpen = !inspi.hasAttribute('hidden');
    if (isOpen) {
      inspi.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      inspi.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  /* Copie d'un message inspi dans la textarea */
  document.addEventListener('click', function (e) {
    var msgBtn = e.target.closest('[data-ei-mama-inspi-pick]');
    if (!msgBtn) return;
    var textarea = $('[data-ei-mama-message]');
    var counter = $('[data-ei-mama-charcount]');
    var inspi = $('[data-ei-mama-inspi]');
    var toggle = $('[data-ei-mama-toggle-inspi]');
    if (textarea) {
      textarea.value = msgBtn.textContent.trim();
      if (counter) counter.textContent = String(textarea.value.length);
    }
    if (inspi) inspi.setAttribute('hidden', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });

  /* Valider le petit mot */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ei-mama-petitmot-valider]')) return;

    var selectedCarton = $('.ei-mama-carton[aria-checked="true"]');
    var textarea = $('[data-ei-mama-message]');
    var carton = selectedCarton ? selectedCarton.dataset.eiMamaCarton : null;
    var message = textarea ? textarea.value.trim() : '';

    /* Validation minimale : un carton OU un message (ou les deux). Si tout vide, on alerte. */
    if (!carton && !message) {
      alert('Choisissez un carton ou écrivez un message pour valider votre petit mot.');
      return;
    }
    if (!carton) {
      alert('Choisissez un carton pour votre petit mot.');
      return;
    }

    var ctx = window.eiMamaState.petitMotContext || {};
    var payload = { carton: carton, message: message };

    if (ctx.source === 'coffret' && ctx.coffretId) {
      window.eiMamaState.coffrets[ctx.coffretId] = payload;
      /* Update le bouton du coffret en état "ajouté" */
      var btn = document.querySelector('[data-ei-mama-petitmot-coffret="' + ctx.coffretId + '"]');
      if (btn) {
        btn.classList.add('is-done');
        var lbl = btn.querySelector('[data-ei-mama-petitmot-label]');
        if (lbl) lbl.textContent = 'Petit mot ajouté';
      }
    } else if (ctx.source === 'compose') {
      window.eiMamaState.compose = payload;
      var composeBtn = document.querySelector('.ei-mama-petitmot-btn--compose');
      if (composeBtn) {
        composeBtn.classList.add('is-done');
        var composeLbl = composeBtn.querySelector('[data-ei-mama-petitmot-label-compose]');
        if (composeLbl) composeLbl.textContent = 'Petit mot ajouté';
      }

      /* 2026-05-15 : on attache le petit mot à TOUS les produits Composez déjà dans le cart
         (filtrés par la property "Coffret Mamma composé" qui les identifie de façon robuste). */
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var composeItems = (cart.items || []).filter(function (item) {
            return item.properties && item.properties['Coffret Mamma composé'];
          });
          if (!composeItems.length) return;
          var props = {
            'Coffret Mamma composé': 'Fête des Mères 2026 — sélection cliente',
            'Carton choisi': payload.carton
          };
          if (payload.message) props['Message à imprimer'] = payload.message;
          /* /cart/change.js update les properties d'un line item à la fois → on chaîne séquentiellement */
          var chain = Promise.resolve();
          composeItems.forEach(function (it) {
            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: it.key, properties: props })
              });
            });
          });
          return chain;
        })
        .then(function () {
          fetchAndUpdateSticky();
          try {
            if (typeof BroadcastChannel === 'function') {
              new BroadcastChannel('ei-cart-sync').postMessage({ type: 'cart-updated' });
            }
          } catch (e) { /* silencieux */ }
        })
        .catch(function () { /* silencieux */ });
    } else if (ctx.source === 'cart-coffret') {
      /* Anti-lymbes : update directement le line item du coffret dans le cart Shopify */
      if (ctx.lineKey) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = (cart.items || []).find(function (it) { return it.key === ctx.lineKey; });
            if (!item) return;
            var props = Object.assign({}, item.properties || {}, {
              'Carton choisi': payload.carton
            });
            if (payload.message) props['Message à imprimer'] = payload.message;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: ctx.lineKey, properties: props })
            });
          })
          .then(function () {
            fetchAndUpdateSticky();
            try {
              if (typeof BroadcastChannel === 'function') {
                new BroadcastChannel('ei-cart-sync').postMessage({ type: 'cart-updated' });
              }
            } catch (e) { /* silencieux */ }
          })
          .catch(function () { /* silencieux */ });
      }
    } else if (ctx.source === 'cart-compose') {
      /* Anti-lymbes : update TOUS les line items Composez du cart (un seul mot pour la sélection) */
      window.eiMamaState.compose = payload;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var composeItems = (cart.items || []).filter(function (item) {
            return item.properties && item.properties['Coffret Mamma composé'];
          });
          if (!composeItems.length) return;
          var props = {
            'Coffret Mamma composé': 'Fête des Mères 2026 — sélection cliente',
            'Carton choisi': payload.carton
          };
          if (payload.message) props['Message à imprimer'] = payload.message;
          var chain = Promise.resolve();
          composeItems.forEach(function (it) {
            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: it.key, properties: props })
              });
            });
          });
          return chain;
        })
        .then(function () {
          fetchAndUpdateSticky();
          try {
            if (typeof BroadcastChannel === 'function') {
              new BroadcastChannel('ei-cart-sync').postMessage({ type: 'cart-updated' });
            }
          } catch (e) { /* silencieux */ }
        })
        .catch(function () { /* silencieux */ });
    } else if (ctx.source === 'cartecadeau') {
      window.eiMamaState.cartecadeau = payload;
      var ccBtn = document.querySelector('.ei-mama-petitmot-btn--cartecadeau');
      if (ccBtn) {
        ccBtn.classList.add('is-done');
        var ccLbl = ccBtn.querySelector('[data-ei-mama-petitmot-label-cartecadeau]');
        if (ccLbl) ccLbl.textContent = 'Petit mot ajouté';
      }
    }

    pushGA4('ei_mama_petitmot_used', {
      carton_choisi: carton,
      source: ctx.source || 'unknown'
    });

    closeAllPopups();
  });

  /* ============================================================
     POP-UP COLLECTION
     ============================================================ */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ei-mama-open-collection]')) {
      openPopup('collection');
    }
  });

  /* Bouton "+ Ajouter un petit mot" depuis le PANIER POPOVER (anti-lymbes).
     Le user a ajouté un coffret ou un produit Composez sans avoir d'abord défini de petit mot.
     Le bouton apparaît dans le cart popover sous le produit → ouvre la popup petit mot ici.
     Au validate, on update le line item via /cart/change.js avec les properties. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ei-mama-add-mot-from-cart]');
    if (!btn) return;
    e.preventDefault();
    var lineKey = btn.dataset.eiLineKey;
    var cartSource = btn.dataset.eiMamaCartSource; /* 'cart-coffret' ou 'cart-compose' */
    var coffretTitle = btn.dataset.eiCoffretTitle || '';
    /* Mémorise le context pour le handler validate */
    window.eiMamaState.petitMotContext = {
      source: cartSource,
      lineKey: lineKey,
      coffretTitle: coffretTitle
    };
    openPopup('petitmot');
  });

  /* "Terminer ma sélection" : 2026-05-15 nouveau flow → ouvre directement la popup petit mot
     (au lieu de fermer + scroller). La cliente définit son petit mot ici, et au validate
     les properties sont appliquées à TOUS les produits Composez déjà dans le panier. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ei-mama-terminer-selection]')) return;
    /* Pré-remplit le context comme un open-petitmot source=compose */
    window.eiMamaState.petitMotContext = { source: 'compose' };
    /* On ferme d'abord la popup Collection si elle est ouverte, puis on ouvre la popup petit mot */
    closeAllPopups();
    setTimeout(function () {
      var openBtn = document.querySelector('[data-ei-mama-open-petitmot][data-ei-mama-petitmot-source="compose"]');
      if (openBtn && openBtn.click) {
        openBtn.click();
      } else {
        openPopup('petitmot');
      }
    }, 220);
  });

  /* "Voir plus de produits" — révèle le batch suivant, cache le bouton si plus de batches */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ei-mama-popup-loadmore]');
    if (!btn) return;
    var nextBatch = parseInt(btn.dataset.currentBatch || '0', 10) + 1;
    var totalBatches = parseInt(btn.dataset.totalBatches || '1', 10);
    $$('[data-ei-mama-batch="' + nextBatch + '"]').forEach(function (el) {
      el.removeAttribute('hidden');
    });
    btn.dataset.currentBatch = String(nextBatch);
    if (nextBatch >= totalBatches - 1) {
      btn.style.display = 'none';
    }
  });

  /* ============================================================
     ATC : enrichissement des forms avec les hidden inputs petit mot
     (Cart V1 intercepte ensuite le submit)
     ============================================================ */

  /* On utilise capture-phase sur submit pour passer AVANT Cart V1 et muter le form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;

    /* Coffret */
    var coffretForm = form.closest('[data-ei-mama-coffret-form]');
    if (coffretForm) {
      var coffretId = coffretForm.dataset.eiMamaCoffretForm;
      var saved = window.eiMamaState.coffrets[coffretId];
      var cartonInput = coffretForm.querySelector('[data-ei-mama-prop="carton"]');
      var messageInput = coffretForm.querySelector('[data-ei-mama-prop="message"]');

      if (saved && saved.carton) {
        if (cartonInput) {
          cartonInput.name = 'properties[Carton choisi]';
          cartonInput.value = saved.carton;
        }
        if (messageInput && saved.message) {
          messageInput.name = 'properties[Message à imprimer]';
          messageInput.value = saved.message;
        } else if (messageInput) {
          messageInput.name = '';
          messageInput.value = '';
        }
      } else {
        if (cartonInput) { cartonInput.name = ''; cartonInput.value = ''; }
        if (messageInput) { messageInput.name = ''; messageInput.value = ''; }
      }

      pushGA4('ei_mama_coffret_atc', { coffret_type: coffretId });
      return; /* Cart V1 prend le relais */
    }

    /* Produit composé (grille ou popup) : ATC AJAX direct, pas de Cart V1 popover */
    var composeForm = form.closest('[data-ei-mama-compose-form]');
    if (composeForm) {
      /* On court-circuite Cart V1 pour ne pas ouvrir le popover à chaque ajout. */
      e.preventDefault();
      e.stopImmediatePropagation();

      var variantInput = composeForm.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var savedCompose = window.eiMamaState.compose;

      var pCarton = composeForm.querySelector('[data-ei-mama-prop="carton"]');
      var pMessage = composeForm.querySelector('[data-ei-mama-prop="message"]');
      var pLead = composeForm.querySelector('[data-ei-mama-prop="lead"]');

      /* 2026-05-15 : TOUS les produits Composez portent le petit mot (plus de "produit porteur").
         Si un mot a été défini avant cet ATC → on injecte Carton + Message directement.
         Si défini APRÈS, le validateur du petit mot (source="compose") update les line items
         existants via /cart/change.js. */
      if (savedCompose && savedCompose.carton) {
        if (pCarton) {
          pCarton.name = 'properties[Carton choisi]';
          pCarton.value = savedCompose.carton;
        }
        if (pMessage && savedCompose.message) {
          pMessage.name = 'properties[Message à imprimer]';
          pMessage.value = savedCompose.message;
        } else if (pMessage) {
          pMessage.name = '';
          pMessage.value = '';
        }
        if (pLead) { pLead.name = ''; pLead.value = ''; }
      } else {
        if (pCarton) { pCarton.name = ''; pCarton.value = ''; }
        if (pMessage) { pMessage.name = ''; pMessage.value = ''; }
        if (pLead) { pLead.name = ''; pLead.value = ''; }
      }

      /* Submit AJAX direct vers /cart/add.js */
      var addBtn = composeForm.querySelector('.ei-mama-gp__add');
      var addBtnOrig = addBtn ? addBtn.textContent : '+ Ajouter';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = '...';
      }

      var formData = new FormData(composeForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: formData
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (addBtn) { addBtn.textContent = addBtnOrig; addBtn.disabled = false; }
            alert('Désolé, ce produit ne peut pas être ajouté pour le moment.');
            return;
          }
          /* Feedback visuel sur le bouton (1.4s) */
          if (addBtn) {
            addBtn.textContent = 'Ajouté ✓';
            addBtn.classList.add('is-added');
            setTimeout(function () {
              addBtn.textContent = addBtnOrig;
              addBtn.classList.remove('is-added');
              addBtn.disabled = false;
            }, 1400);
          }
          /* === Optimistic update (instantané, pas de latence perçue) ===
             On incrémente le badge avec la quantité ajoutée AVANT le fetch /cart.js
             pour que l'utilisateur voie le compteur bouger immédiatement.
             Le fetch /cart.js suivant ajuste si besoin (auto-correction). */
          var addedQty = (res.data && res.data.quantity) || 1;
          $$('.enj-cartcount, [data-cart-count], .js-number-cart, .number-cart').forEach(function (el) {
            var current = parseInt((el.textContent || '0').replace(/\D/g, ''), 10) || 0;
            var next = current + addedQty;
            el.textContent = next;
            if (next > 0) el.classList.add('has-items');
          });

          /* Update sticky bar + badge Cart V1 + broadcast */
          fetchAndUpdateSticky();
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              /* Bug 2026-05-15 : ajout .js-number-cart + .number-cart pour update le compteur natif Vegai du header desktop (filet panier) qui n'a pas .enj-cartcount */
              $$('.enj-cartcount, [data-cart-count], .js-number-cart, .number-cart').forEach(function (el) {
                el.textContent = cart.item_count;
                if (cart.item_count > 0) el.classList.add('has-items');
              });
            });
          try {
            if (typeof BroadcastChannel === 'function') {
              new BroadcastChannel('ei-cart-sync').postMessage({ type: 'cart-updated' });
            }
          } catch (eb) { /* silencieux */ }
        })
        .catch(function () {
          if (addBtn) { addBtn.textContent = addBtnOrig; addBtn.disabled = false; }
        });

      pushGA4('ei_mama_compose_atc', {
        source: composeForm.dataset.eiMamaSource || 'lp'
      });
      return;
    }
  }, true); /* capture-phase : on passe AVANT Cart V1 */

  /* ============================================================
     STICKY BAR : read /cart.js + progression livraison
     ============================================================ */
  var sticky = $('[data-ei-mama-sticky]');
  var stickyTotal = $('[data-ei-mama-sticky-total]');
  var stickyFill = $('[data-ei-mama-sticky-fill]');
  var stickyMsg = $('[data-ei-mama-sticky-msg]');

  function updateSticky(cart) {
    if (!sticky || !cart) return;
    var subtotal = cart.original_total_price || cart.total_price || 0;
    if (stickyTotal) stickyTotal.textContent = formatMoney(subtotal);

    /* Cible : prochain palier non encore atteint */
    var target, label;
    if (subtotal < SEUIL_RELAIS) {
      target = SEUIL_RELAIS;
      label = 'point relais';
    } else if (subtotal < SEUIL_DOMICILE) {
      target = SEUIL_DOMICILE;
      label = 'livraison à domicile';
    } else {
      target = SEUIL_DOMICILE;
      label = null;
    }

    var pct = Math.min(100, Math.round((subtotal / target) * 100));
    if (stickyFill) stickyFill.style.width = pct + '%';

    if (stickyMsg) {
      if (label) {
        var remaining = Math.max(0, target - subtotal);
        stickyMsg.textContent = 'Plus que ' + formatMoney(remaining) + ' pour la livraison à ' + label + ' offerte';
      } else {
        stickyMsg.textContent = '✓ Livraison à domicile offerte';
      }
    }
  }

  function fetchAndUpdateSticky() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateSticky(cart); })
      .catch(function () { /* silencieux */ });
  }

  /* Anti-doublon : la sticky bar Mamma se cache automatiquement quand le filet panier
     du header (.js-call-minicart) est visible dans le viewport, et s'affiche sinon.
     On observe TOUS les filets panier (desktop + mobile burger + bottom-tab) et on
     considère le filet "visible" si au moins un l'est. */
  if (sticky && typeof IntersectionObserver === 'function') {
    var visibleCartIcons = new Set();
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleCartIcons.add(entry.target);
        else visibleCartIcons.delete(entry.target);
      });
      sticky.classList.toggle('is-hidden', visibleCartIcons.size > 0);
    }, { threshold: 0 });
    document.querySelectorAll('.js-call-minicart').forEach(function (el) {
      stickyObserver.observe(el);
    });
    /* État initial : on cache la sticky par défaut, l'observer la révélera si aucun
       filet n'est visible au chargement. */
    sticky.classList.add('is-hidden');
  }

  /* Bouton Panier de la sticky : ouvrir Cart V1 (clic simulé sur l'icône panier native).
     Bug 2026-05-15 : les sélecteurs .enj-cart-icon / [data-cart-count] n'existent pas
     dans le DOM Vegai actuel → on tombait sur le fallback /cart. La vraie classe que
     Cart V1 écoute est .js-call-minicart (présente sur header desktop + mobile burger). */
  if (sticky) {
    sticky.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ei-mama-open-cart]')) return;
      e.preventDefault();
      /* Sélecteurs ordonnés par préférence : data-attr explicite → minicart Vegai → fallback */
      var nativeCartIcon = document.querySelector('[data-ei-open-cart], .js-call-minicart');
      if (nativeCartIcon && nativeCartIcon.click) {
        nativeCartIcon.click();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  /* Refresh sticky après chaque ATC + via BroadcastChannel Cart V1 */
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
      setTimeout(fetchAndUpdateSticky, 600);
    }
  });

  if (typeof BroadcastChannel === 'function') {
    try {
      var bc = new BroadcastChannel('ei-cart-sync');
      bc.addEventListener('message', function (ev) {
        if (ev.data && ev.data.type === 'cart-updated') fetchAndUpdateSticky();
      });
    } catch (e3) { /* silencieux */ }
  }

  /* Visibility change : refresh quand l'onglet redevient actif */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fetchAndUpdateSticky();
  });

  /* ============================================================
     BLOC 8 — CARTE CADEAU (Étape 2)
     ============================================================
     - Sélection design (1 sur 4)
     - Sélection montant (1 sur 4)
     - Validation email avant submit
     - ATC enrichi avec line item properties (design, email, petit mot)
     ============================================================ */

  /* Sélection design : 1 seul actif à la fois */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ei-mama-cc-design]');
    if (!btn) return;
    $$('.ei-mama-cc-design').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
  });

  /* Sélection montant : 1 seul actif à la fois */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ei-mama-cc-montant]');
    if (!btn) return;
    $$('.ei-mama-cc-montant').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
  });

  /* Validation email simple (regex non strict mais correct pour 99% des cas) */
  function isValidEmail(v) {
    if (!v) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  /* Submit du form gift card : valide email destinataire + montant, pose variant id + design.
     2026-05-15 : refactoré pour utiliser le recipient form natif Shopify.
     Les champs Recipient email / name / Message / Send on sont déjà nommés correctement
     dans le HTML (`name="properties[...]"`), Shopify les traite automatiquement.
     Notre JS ne fait que valider et activer la variant. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.closest('[data-ei-mama-cc-form]')) return;

    var emailInput = form.querySelector('[data-ei-mama-cc-recipient-email]');
    var email = emailInput ? emailInput.value.trim() : '';
    var selectedDesign = form.querySelector('[data-ei-mama-cc-design][aria-checked="true"]')
                      || document.querySelector('[data-ei-mama-cc-design][aria-checked="true"]');
    var design = selectedDesign ? selectedDesign.dataset.eiMamaCcDesign : 'Floral';
    var selectedMontant = form.querySelector('[data-ei-mama-cc-montant][aria-checked="true"]');

    /* Validations bloquantes */
    if (!isValidEmail(email)) {
      e.preventDefault();
      e.stopPropagation();
      if (emailInput) {
        emailInput.classList.add('is-invalid');
        emailInput.focus();
      }
      alert('Merci de saisir un email valide pour le destinataire de la carte cadeau.');
      return;
    }
    if (!selectedMontant) {
      e.preventDefault();
      e.stopPropagation();
      alert('Choisissez un montant pour votre carte cadeau.');
      return;
    }

    var variantId = selectedMontant.dataset.eiMamaCcVariant;
    var montant = selectedMontant.dataset.eiMamaCcMontant;

    /* Peupler les hidden inputs */
    var idInput = form.querySelector('[data-ei-mama-cc-id]');
    if (idInput) idInput.value = variantId;

    var propDesign = form.querySelector('[data-ei-mama-cc-prop-design]');
    if (propDesign) propDesign.value = design;

    pushGA4('ei_mama_cartecadeau_atc', { montant: parseInt(montant, 10) });
    /* Cart V1 prend le relais sur le submit */
  }, true);

  /* Retirer l'état invalid email destinataire dès qu'on tape */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-ei-mama-cc-recipient-email]')) {
      e.target.classList.remove('is-invalid');
    }
  });

  /* ============================================================
     TRACKING GA4
     ============================================================ */

  /* ei_mama_view : à l'init */
  pushGA4('ei_mama_view', {});

  /* ei_mama_scroll_50 : 1 seule fois */
  var scroll50Fired = false;
  window.addEventListener('scroll', function () {
    if (scroll50Fired) return;
    var doc = document.documentElement;
    var scrolled = (window.scrollY || window.pageYOffset) + window.innerHeight;
    var totalHeight = Math.max(doc.scrollHeight, doc.offsetHeight);
    if (totalHeight > 0 && (scrolled / totalHeight) >= 0.5) {
      scroll50Fired = true;
      pushGA4('ei_mama_scroll_50', {});
    }
  }, { passive: true });

  /* ei_mama_checkout : clic vers le checkout depuis la LP
     Détection : tout lien/bouton dont href contient /checkout */
  document.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (!checkoutLink) return;
    pushGA4('ei_mama_checkout', {});
  });

  /* ============================================================
     INIT
     ============================================================ */
  fetchAndUpdateSticky();

})();
